import {getScrollTop} from '../../common/utils/get-scroll';
import {getViewportHeight} from '../../common/utils/size';
import PageComponent from '../../common/component/page-component';

const names = {
	itemAttr: 'item',
	expandAttr: 'expand',
	linkAttr: 'link',
	menuAttr: 'menu',
	openedClass: 'opened',
	selectedClass: 'selected',
	currentLinkClass: 'currentLink',
	lastLevelClass: 'lastLevel',
	withChildrenClass: 'withChildren',
};

class SideMenu extends PageComponent {
	prepare() {
		this.isScrollEnabled = false;
		this.isSticky = false;
		this.previousScrollTop = 0;
		this.offset = 0;
		this.menu = this.element.querySelector(this.dataSelector(names.menuAttr));
		this.menuStyle = getComputedStyle(this.menu);
		this.itemSelected = this.element.querySelector(this.classSelector(names.selectedClass));

		this.listeners.expand = this.events.on(this.element, this.dataSelector(names.expandAttr), 'click', this.onExpandClick.bind(this));
		this.listeners.link = this.events.on(
			this.element,
			this.dataSelector(names.linkAttr) + this.classSelector(names.currentLinkClass),
			'click',
			this.onCurrentLinkClick.bind(this)
		);
		this.listeners.resize = this.events.on(window, 'window:resize', this.onResize.bind(this));
		// this.listeners.contentResize = this.events.on(this.element, 'content:resize', this.onResize.bind(this));
		// this.listeners.scroll = this.events.on(window, 'window:scroll', this.onScroll.bind(this));
		this.updateSize();
	}

	onExpandClick(event, target) {
		const item = target.closest(this.dataSelector(names.itemAttr));
		this.selectItem(item);
	}

	onCurrentLinkClick(event, target) {
		event.preventDefault();
		const item = target.closest(this.dataSelector(names.itemAttr));
		if (item && item.matches(this.classSelector(names.withChildrenClass))) {
			this.selectItem(item);
		}
	}

	onResize(event) {
		this.updateSize();
	}

	onScroll(event) {
		const scrollTop = getScrollTop();
		this.updatePosition(scrollTop);
	}

	selectItem(item) {
		console.log('prev selected', this.itemSelected);
		const isOpened = item.matches(this.classSelector(names.lastLevelClass));
		if (!isOpened && this.itemSelected && item !== this.itemSelected && !item.contains(this.itemSelected) && !this.itemSelected.contains(item)) {
			this.toggleItemSelection(this.itemSelected, false);
			this.itemSelected = null;
		}
		if (isOpened) {
			const parent = item.parentNode.closest(this.dataSelector(names.itemAttr));
			if (parent) {
				this.toggleItemSelection(parent, true);
				this.itemSelected = parent;
			} else {
				this.toggleItemSelection(item, false);
				this.itemSelected = null;
			}
		} else {
			this.toggleItemSelection(item, true);
			this.itemSelected = item;
		}
	}

	toggleItemSelection(item, select = true) {
		const descendantsOpened = item.querySelectorAll(this.dataSelector(names.itemAttr) + this.classSelector(names.openedClass));
		for (const descendantOpened of descendantsOpened) {
			this.classList(descendantOpened).remove(names.openedClass, names.lastLevelClass);
		}
		const lastLevelAncestor = item.closest(this.classSelector(names.lastLevelClass));
		if (lastLevelAncestor) {
			this.classList(lastLevelAncestor).remove(names.lastLevelClass);
		}
		const selected = this.element.querySelector(this.classSelector(names.selectedClass));
		if (selected) {
			this.classList(selected).remove(names.selectedClass);
		}
		this.classList(item)[select ? 'add' : 'remove'](names.openedClass, names.lastLevelClass, names.selectedClass);
	}

	updateSize() {
		if (this.menuStyle.position === 'sticky') {
			let promise = Promise.resolve();
			if (this.contexts.getCurrentContext().getName() === 'menu') {
				promise = this.contexts.pop();
			}
			promise.then(() => {
				const elementRect = this.element.getBoundingClientRect();
				const scrollTop = getScrollTop();
				this.stickyTopPosition = scrollTop + elementRect.top;
				this.viewportHeight = getViewportHeight();
				this.menuHeight = this.menu.getBoundingClientRect().height;
				this.menuTop = parseInt(this.menuStyle.top, 10);
				this.updatePosition(scrollTop);
				this.enableScrollMonitor();
			});
		} else {
			this.disableScrollMonitor();
		}
	}

	updatePosition(scrollTop) {
		const scrollDiff = scrollTop - this.previousScrollTop;
		this.previousScrollTop = scrollTop;
		const isSticky = scrollTop > this.stickyTopPosition;
		if (isSticky) {
			const diff = this.menuTop + this.menuHeight - this.viewportHeight;
			const isFitting = diff < 0;
			if (!isFitting) {
				this.offset += scrollDiff;
				this.offset = Math.max(0, Math.min(diff, this.offset));
				this.menu.style.transform = 'translateY(-' + this.offset + 'px)';
			} else {
				this.menu.style.transform = 'translateY(0)';
			}
		} else {
			if (this.isSticky) {
				this.menu.style.removeProperty('transform');
			}
		}
		this.isSticky = isSticky;
	}

	enableScrollMonitor() {
		if (!this.isScrollEnabled) {
			this.isScrollEnabled = true;
			this.listeners.scroll = this.events.on(window, 'window:scroll', this.onScroll.bind(this));
		}
	}

	disableScrollMonitor() {
		if (this.isScrollEnabled) {
			this.isScrollEnabled = false;
			this.listeners.scroll.destroy();
			delete this.listeners.scroll;
		}
	}
}

export default SideMenu;
